/**
 * Chunk and Area of Interest (AOI) configuration.
 * Single source of truth for chunk-related settings.
 */
export const CHUNK_CONFIG = {
  // AOI radii (in chunks from player's current chunk)
  AOI_LOAD_RADIUS: 1,
  AOI_UNLOAD_RADIUS: 2,
  SIMULATION_RADIUS: 3,
} as const;

/**
 * Asset path configuration.
 * Single source of truth for asset URL paths used by client and server.
 */
export const ASSET_CONFIG = {
  /** URL path root for sprite assets (used in fetch/load calls) */
  SPRITES_URL_PATH: '/assets/sprites',
} as const;

/**
 * Interaction configuration.
 * Single source of truth for distances and ranges.
 */
export const INTERACTION_CONFIG = {
  /** Maximum distance from which a hint starts to appear (in world units) */
  HINT_RADIUS: 8,
  /** Maximum distance from which a player can initiate an interaction (in world units) */
  EXECUTE_RADIUS: 4,
  /** Distance at which an active interaction is automatically "broken" */
  EXIT_RADIUS: 12,
} as const;

/**
 * Line of sight configuration.
 */
export const LOS_CONFIG = {
  /** Default tile range used by the first-pass tile cone */
  DEFAULT_TILE_RANGE: 8,
} as const;

/**
 * Movement configuration.
 */
export const MOVEMENT_CONFIG = {
  /**
   * Forgiveness factor for server-side movement validation.
   * 0.1 = 10% tolerance for floating point drift or minor latency.
   */
  VALIDATION_TOLERANCE: 0.1,

  /** Frequency of client-to-server position sync (in ms) */
  SYNC_INTERVAL_MS: 50, // 20Hz

  /**
   * The baseline speed used to normalize animation playback speed.
   * Entities moving at this speed will have their animation play at 1.0x.
   */
  ANIMATION_BASELINE_SPEED: 80,
} as const;
